<template>
  <div class="c-fill" v-if="fills">
    <dry :index="fillIndex" :content="fill.content" :course="fill.course" v-for="(fill, fillIndex) in fills" :key="fillIndex">
      <div class="c-fill-item-warp" :class="[trigger ? 'choosed' : '', fill.answer == fill.userAnswer ? 'trueAns' : 'worryAns']">
        <!-- :disabled="trigger" -->
        <input class="c-fill-item-content" type="text" v-model="fill.userAnswer" @focus="focusHandle(fill)" @blur="blurHandle(fill)">
      </div>
      <p class="c-fill-item-trueAns" v-if="trigger && fill.answer != fill.userAnswer">
        正确答案:
        <span>{{fill.answer}}</span>
      </p>
    </dry>
  </div>
</template>

<script>
import Dry from './dry'

export default {
  props: {
    trigger: {
      type: Boolean,
      default: false
    },
    fills: {
      type: Array,
      default: null
    }
  },
  components: {
    Dry
  },
  data () {
    return {
    }
  },
  watch: {
    trigger: function () {
      this.fills.forEach((v) => {
        if (v.answer === v.userAnswer) {
          this.$parent.fraction += parseInt(v.course)
        }
      })
    }
  },
  methods: {
    focusHandle (fill) {
      if (fill.userAnswer == '请输入答案') {
        fill.userAnswer = ''
      }
    },
    blurHandle (fill) {
      if (!fill.userAnswer) {
        fill.userAnswer = '请输入答案'
      }
    }
  }
}
</script>

<style lang="scss">
.c-fill{
  max-width: 1200px;
  margin: 0 auto;
  .c-fill-item{
    margin-bottom: 50px;
  }
  .c-fill-item-title{
    span{
      font-weight:700;
      position: absolute;
      left: 0;
      top: 0;
    }
    position: relative;
    padding-left: 22px;
    line-height: 21px;
    font-size: 16px;
    margin-bottom: 25px;
  }
  .c-fill-item-warp{
    position: relative;
    overflow: hidden;
    border-radius: 8px;
    border: 2px solid #E2E2E2;
    background-color: #F6F6F6;
    .c-fill-item-content{
      line-height: 53px;
      width: 100%;
      box-sizing: border-box;
      padding-left: 20px;
      color: #AAABAC;
      font-size: 14px;
      outline: none;
      border: none;
    }
    &::after{
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 0 32px 32px;
      border-color: transparent transparent transparent transparent;
      position: absolute;
      bottom: 0;
      right: 0;
      content: '';
    }
    &.choosed input{
      cursor: text;
    }
    &.choosed.trueAns{
      border-color: #29C23D;
      &::after{
        border-color: transparent transparent #29C23D transparent;
      }
      &::before{
        background-image: url('../../../static/images/hook.png');
        background-size: cover;
        position: absolute;
        width: 13px;
        height: 10px;
        content: '';
        bottom: 5px;
        right: 4px;
        z-index: 1;
      }
    }
    &.choosed.worryAns{
      border-color: #FE5454;
      &::after{
        border-color: transparent transparent #FE5454 transparent;
      }
      &::before{
        background-image: url('../../../static/images/cross.png');
        background-size: cover;
        position: absolute;
        width: 11px;
        height: 11px;
        content: '';
        bottom: 3px;
        right: 3px;
        z-index: 1;
      }
    }
  }
  .c-fill-item-trueAns{
    margin-top: 20px;
    font-size: 14px;
    line-height: 20px;
    span{
      color: #29C23D;
      line-height: 20px;
    }
  }
}
@media screen and (max-width: 768px){
.c-fill{
  .c-fill-item-warp{
    border-radius: 8px;
    min-height: 35px;
    margin-bottom: 15px;
    margin-right: 0;
    .c-fill-item-content{
      line-height: 35px;
    }
    &::after{
      border-width: 0 0 20px 20px;
    }
    &.choosed.worryAns{
      &::before{
        width: 7px;
        height: 7px;
        bottom: 2px;
        right: 3px;
      }
    }
    &.choosed.trueAns{
      &::before{
        width: 9px;
        height: 7px;
        bottom: 3px;
        right: 2px;
      }
    }
    .c-fill-item-helper{
      height: 35px;
      line-height: 35px;
    }
  }
}}
</style>
